import { Box, Text, Textarea, VStack } from '@chakra-ui/react';
import React from 'react';
import { useFormikContext } from 'formik';
import { localise } from '../../../services/lang/lang';
import NotesList from './NotesList';
import { useTokens } from '../../../context/TokenProvider';
import { makeMed4 } from '../../../styles/textStyles';
import { useTrackUnsavedChanges } from '../UnsavedChanges/useTrackUnsavedChanges';
import AddButton from '../AddButton/AddButton';
const Notes = ({ notes, onNotesMutated, canEdit }) => {
    const { values, isSubmitting, dirty, handleSubmit, handleChange } = useFormikContext();
    useTrackUnsavedChanges(dirty);
    const tokens = useTokens();
    return (React.createElement(Box, { "data-testid": "notes_component" },
        React.createElement(VStack, { align: "start", gap: tokens.Spacing04 },
            React.createElement(Textarea, { value: values.content, onChange: handleChange, name: "content", w: "100%", isDisabled: isSubmitting || !canEdit, variant: "primary", placeholder: localise('ADD_NOTE_PLACEHOLDER'), p: tokens.Spacing04 }),
            React.createElement(AddButton, { isDisabled: !dirty || !canEdit, isLoading: isSubmitting, onClick: () => handleSubmit() },
                React.createElement(Text, { sx: makeMed4(tokens) }, localise('ADD')))),
        React.createElement(Box, { mt: tokens.Spacing06 },
            React.createElement(NotesList, { notes: notes, onNotesMutated: onNotesMutated, canEdit: canEdit }))));
};
export default Notes;
